// STEP UX-2 (2026-09-10 판매자 지시 §5·§6·§14) — Common Home + LIVE-only
// card for Naver + Kakao (+ future TikTok/Instagram/YouTube 확장).
// · Fixed aspect ratio · object-fit: cover · platform-badge only.
// · Never renders per-platform sized cards (§14).
// · Routes to LIVEMOA Watch Hub (§15 · §20) — never direct-links to the
//   external Naver / Kakao page (§17: no iframe · no rehost · no proxy).
import React from 'react';
import { Link } from 'react-router-dom';
import SafeImg from '@/components/SafeImg';

// Green (Naver brand) · Yellow (Kakao brand) · fallback red for
// LIVEMOA / SNS · text-color follows contrast rule.
const BADGE = {
  naver_shopping_live: { color: '#03C75A', text: '#ffffff', label: '네이버' },
  kakao_shopping_live: { color: '#FEE500', text: '#1a1a1a', label: '카카오' },
};

const HomeLiveCard = ({ live }) => {
  const b = BADGE[live.platform] || {
    color: '#FF3B30', text: '#ffffff', label: live.platform_name || 'LIVE',
  };
  return (
    <Link
      to={`/live/hub/${live.external_id}`}
      className="group block bg-white dark:bg-[#141414] border border-black/5 dark:border-white/10 rounded-xl overflow-hidden hover:-translate-y-0.5 hover:shadow-md transition-all duration-200"
      data-testid={`home-live-card-${live.external_id}`}
    >
      <div className="relative aspect-video overflow-hidden bg-gray-100 dark:bg-gray-800">
        <SafeImg
          src={live.thumbnail_url}
          kind="broadcast"
          alt={live.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
        />
        <div className="absolute top-2 left-2 flex gap-1.5">
          <span
            className="px-2 py-0.5 rounded-full bg-[#FF3B30] text-white text-[10px] font-bold animate-pulse"
            data-testid="home-live-badge"
          >
            🔴 LIVE
          </span>
          <span
            className="px-2 py-0.5 rounded-full text-[10px] font-bold"
            style={{ background: b.color, color: b.text }}
            data-testid={`home-live-platform-${live.platform}`}
          >
            {b.label}
          </span>
        </div>
      </div>
      <div className="p-3">
        <h3
          className="font-bold text-sm leading-snug line-clamp-2 mb-1"
          style={{ fontFamily: 'Manrope, sans-serif' }}
          data-testid="home-live-title"
        >
          {live.title}
        </h3>
        <p className="text-[11px] text-gray-500 dark:text-gray-400 truncate" data-testid="home-live-seller">
          {live.seller_name || live.platform_name}
        </p>
      </div>
    </Link>
  );
};

export default HomeLiveCard;
